'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'cherries';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = 'M288 8l3.9-7c-2.5-1.4-5.5-1.3-7.9 .1S280 5.2 280 8l11.9-7L280 8s0 0 0 0s0 0 0 0c0 0 0 0 0 .1l0 .3 0 1.2c0 1.1-.1 2.7-.2 4.8c-.2 4.2-.5 10.4-1.3 18.2c-1.5 15.6-4.4 37.5-10.3 62.5c-11.8 50.3-35.4 112.8-82.1 163.4l-.1 .1C172.9 247.8 139.2 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-32 192-176c0-79.9-56.7-103.2-83-109.6c-8.6-2.1-17.5-2.6-26.3-1.6c-22.4 2.5-41.6 10.9-55.8 19.3c35.5-47.8 54.6-101.4 64.9-145.2c6.1-25.9 9.1-48.5 10.7-64.7c.4-4.6 .7-8.7 1-12.2c3.6 2.4 8 5.3 12.9 8.9c14.7 10.6 34.3 26.6 53.8 47.6c37.9 40.7 75.3 100.2 77.7 177.7c-1.5-.6-2.9-1.4-4.1-2.3c-12.8-9.5-34.9-22.9-62.5-27.9c6.8 6.2 13.1 13.5 18.7 21.8c14.3 5.5 26.1 12.9 34.2 18.9c12.8 9.5 30.8 9.5 43.6 0c14.7-10.9 41.6-26.6 74.1-26.6c0 0 0 0 0 0l.5 0c.5 0 1.3 .1 2.3 .1c2.1 .2 5.3 .5 9.1 1.3c7.8 1.5 18 4.5 28 10.4C603 262.9 624 285.6 624 336c0 74-32.7 112.8-69.9 134.1C515.6 492.1 470.8 496 448 496c-17.3 0-49.6-4.8-81.8-19.1c-3.9 4.2-8 8.2-12.2 12C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-37.5 0-67.8 17.9-83.7 29.8c-1.4 1-2.8 1.8-4.4 2.4c-2.4-82.9-42.4-146.1-82-188.7C353.4 45.6 333 29 317.7 17.9c-7.7-5.6-14.1-9.8-18.6-12.6c-2.3-1.4-4-2.5-5.3-3.2c-.6-.4-1.1-.6-1.4-.8l-.4-.2-.1-.1c0 0 0 0 0 0s0 0 0 0L288 8zM180.7 275.3s0 0 0 0s0 0 0 0s0 0 0 0c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7c0 0 0 0 0 0s0 0 0 0l.2-.2c.2-.2 .5-.5 .9-.8c.8-.8 2.1-1.9 3.9-3.4c3.5-2.9 8.7-6.9 15.3-11c13.3-8.3 31.7-16.9 53-19.3c7-.8 14.1-.4 20.7 1.3c11.7 2.9 29.4 9.4 44.1 23.3C355.5 278.7 368 300.3 368 336c0 65.5-32.2 104.8-70.4 128.4c-39 24.2-84 31.6-105.6 31.6s-66.5-7.4-105.6-31.6C48.2 440.8 16 401.5 16 336c0-50.4 21-73.1 40.1-84.2c10-5.9 20.2-8.9 28-10.4c3.9-.7 7-1.1 9.1-1.3c1.1-.1 1.9-.1 2.3-.1l.5 0c0 0 0 0 0 0c24.2 0 45.3 8.7 60.8 17.8c7.7 4.5 13.8 9 17.9 12.4c2.1 1.7 3.6 3 4.6 3.9c.5 .5 .9 .8 1.1 1l.2 .2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;